import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class VueSelect extends Vue {
    
    @Prop()
    public value: any;

    @Prop()
    public placeholder: any;

    @Prop()
    public options: any;

    @Prop()
    public defaultValue: string;

    public update(val: any) {
        var select = <HTMLSelectElement>this.$refs.select;
        this.$emit('input', select.value);
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/VueSelect/VueSelect.ts